import React from 'react';
import { t } from '../services/translation';

interface ProgressBarProps {
  currentStep: 1 | 2 | 3;
}

const getSteps = () => [
  { num: 1, label: t('Belépési adatok') },
  { num: 2, label: t('Személyes adatok') },
  { num: 3, label: t('Szakmai adatok') },
];

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8l3.5 3.5L13 4.5" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  return (
    <div className="jw-progress" role="navigation" aria-label={t('Regisztrációs lépések')}>
      {getSteps().map((step) => {
        const isDone = step.num < currentStep;
        const isActive = step.num === currentStep;
        return (
          <div
            key={step.num}
            className={`jw-progress-step${isDone ? ' done' : ''}${isActive ? ' active' : ''}`}
            aria-current={isActive ? 'step' : undefined}
          >
            <div className="jw-progress-bubble" aria-hidden="true">
              {isDone ? <CheckIcon /> : step.num}
            </div>
            <span className="jw-progress-label">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
